var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "table offer-info" },
    [
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: "3" } },
            [
              _vm.showCopyToNewRound
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.copyToNewRound()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("ssrManage.copyToNewRound")))]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm.showPqcp
        ? _c(
            "div",
            [
              _vm._v("PQCP "),
              _vm.canEdit
                ? _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.addPqcp } },
                    [_vm._v("New")]
                  )
                : _vm._e(),
              _vm.canEdit
                ? _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.delPqcp } },
                    [_vm._v("Delete")]
                  )
                : _vm._e(),
              _c("pqcp-table", {
                ref: "pqcpList",
                attrs: {
                  "can-edit": _vm.canEdit,
                  data: _vm.formData.ssrRoundSupplierPqcps,
                },
                on: {
                  "update:data": function ($event) {
                    return _vm.$set(
                      _vm.formData,
                      "ssrRoundSupplierPqcps",
                      $event
                    )
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.showPcn
        ? _c(
            "div",
            [
              _vm._v("PQCP "),
              _vm.canEdit
                ? _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.addPcn } },
                    [_vm._v("New")]
                  )
                : _vm._e(),
              _vm.canEdit
                ? _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.delPcn } },
                    [_vm._v("Delete")]
                  )
                : _vm._e(),
              _c("pcn-table", {
                ref: "pcnList",
                attrs: {
                  "can-edit": _vm.canEdit,
                  data: _vm.formData.ssrRoundSupplierPcns,
                },
                on: {
                  "update:data": function ($event) {
                    return _vm.$set(
                      _vm.formData,
                      "ssrRoundSupplierPcns",
                      $event
                    )
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.showCostBreakdown
        ? _c(
            "div",
            { staticStyle: { "padding-top": "15px" } },
            [
              _vm._v("Cost Breakdown "),
              _vm.canEdit
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.addCostBreakdown },
                    },
                    [_vm._v("New")]
                  )
                : _vm._e(),
              _vm.canEdit
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.delCostBreakdown },
                    },
                    [_vm._v("Delete")]
                  )
                : _vm._e(),
              _c("capacity-table", {
                ref: "ssrRoundSupplierCosts",
                attrs: {
                  roundId: _vm.round.ttSsrRoundId,
                  suppliers: _vm.round.ssrRoundSuppliers,
                  files: _vm.round.ssrRoundSuppliers[0].costBreakdownFiles,
                  type: "costBreakdown",
                  template: _vm.formData.costBreakdownTemplate,
                  "can-edit": _vm.canEdit,
                  data: _vm.formData.ssrRoundSupplierCosts,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.showCapacityAnalysis
        ? _c(
            "div",
            { staticStyle: { "padding-top": "15px" } },
            [
              _vm._v("Capacity Analysis "),
              _vm.canEdit
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.addCapacityData },
                    },
                    [_vm._v("New")]
                  )
                : _vm._e(),
              _vm.canEdit
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.delCapacityData },
                    },
                    [_vm._v("Delete")]
                  )
                : _vm._e(),
              _c("capacity-table", {
                ref: "ssrRoundSupplierCapacities",
                attrs: {
                  roundId: _vm.round.ttSsrRoundId,
                  suppliers: _vm.round.ssrRoundSuppliers,
                  files: _vm.round.ssrRoundSuppliers[0].capacityFiles,
                  type: "capacityAnalysis",
                  "my-plants": _vm.myPlants,
                  template: _vm.formData.capacityTemplate,
                  "can-edit": _vm.canEdit,
                  data: _vm.formData.ssrRoundSupplierCapacities,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.showLogisticCapacity
        ? _c(
            "div",
            { staticStyle: { "padding-top": "15px" } },
            [
              _vm._v("Logistics Capacity "),
              _vm.canEdit
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.addLogisticCapacity },
                    },
                    [_vm._v("New")]
                  )
                : _vm._e(),
              _vm.canEdit
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.delLogisticCapacity },
                    },
                    [_vm._v("Delete")]
                  )
                : _vm._e(),
              _c("logistic-info-table", {
                ref: "ssrRoundSupplierLogistics",
                attrs: {
                  data: _vm.formData.ssrRoundSupplierLogistics,
                  "can-edit": _vm.canEdit,
                },
                on: {
                  "update:data": function ($event) {
                    return _vm.$set(
                      _vm.formData,
                      "ssrRoundSupplierLogistics",
                      $event
                    )
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _c("div", { staticStyle: { "padding-top": "15px" } }, [
        _c(
          "div",
          [
            _c(
              "el-card",
              { attrs: { header: "SSR Proposal" } },
              [
                _vm.canEdit
                  ? _c(
                      "el-upload",
                      {
                        ref: "proposalDocUpload",
                        attrs: {
                          headers: _vm.uploadHeader,
                          "show-file-list": false,
                          action: _vm.fileUploadUrl,
                          "on-success": _vm.proposalDocUploadSuccess,
                          multiple: "",
                        },
                      },
                      [
                        _c("el-button", { attrs: { type: "primary" } }, [
                          _vm._v("Upload"),
                        ]),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._l(
                  _vm.formData.ssrRoundSuppliers[0].proposalDocs,
                  function (file, index) {
                    return _c(
                      "div",
                      { key: index, staticStyle: { "line-height": "40px" } },
                      [
                        _c(
                          "el-link",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.downloadFile(file)
                              },
                            },
                          },
                          [_vm._v(_vm._s(file.documentName))]
                        ),
                        _vm.canEdit
                          ? _c("el-button", {
                              staticStyle: { "margin-left": "20px" },
                              attrs: {
                                type: "danger",
                                size: "mini",
                                icon: "el-icon-delete",
                                circle: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.delProposalDocs(file, index)
                                },
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    )
                  }
                ),
              ],
              2
            ),
          ],
          1
        ),
      ]),
      _vm.showOtherFormat
        ? _c("file-upload", {
            attrs: {
              disabled: !_vm.canEdit,
              title: "Other  Format",
              "show-file-list": false,
              multiple: "",
              "biz-id": _vm.formData.ssrRoundSuppliers[0].ttSsrRoundSupplierId,
              "rec-type": "SSR",
              seq: "OTHER_FORMAT",
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "header",
                  fn: function () {
                    return [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.downloadSsrOtherFormat },
                        },
                        [_vm._v("Download")]
                      ),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              664376239
            ),
            model: {
              value: _vm.formData.ssrRoundSuppliers[0].otherFormat,
              callback: function ($$v) {
                _vm.$set(_vm.formData.ssrRoundSuppliers[0], "otherFormat", $$v)
              },
              expression: "formData.ssrRoundSuppliers[0].otherFormat",
            },
          })
        : _vm._e(),
      _c(
        "el-row",
        {
          staticStyle: { "padding-top": "15px" },
          attrs: { type: "flex", justify: "center" },
        },
        [
          _vm.canEdit
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.save("SUBMIT")
                    },
                  },
                },
                [_vm._v("Submit")]
              )
            : _vm._e(),
          _vm.canEdit
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.save("DRAFT")
                    },
                  },
                },
                [_vm._v("Save As Draft")]
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }